import AboutDown from "assets/images/AboutDown.png";
import ImgAboutMobile from "assets/images/about_mobile.svg";
// import ImgAboutMobile from "assets/images/about_mobile.png";
import ImgAboutMobileEn from "assets/images/about_mobile_en.svg";
// import ImgAboutMobileEn from "assets/images/about_mobile_en.png";
import useWindowSize, { Size } from "hooks/useWindowSize";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./style";

function About() {
  const { t, i18n } = useTranslation("common");
  const checkRef = useRef(null);
  const size: Size = useWindowSize();
  const checkSize = size.width && size.width <= 900;
  const checkBreak = size.width && (size.width <= 540 || 1024 <= size.width);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const element: any = checkRef.current;
    const position = element?.getBoundingClientRect();
    console.log("position?.top", position?.top);

    if (position?.top <= 300) {
      element.classList.add("container-animation");
    }
  };

  const ScrollToCenter = (e: any) => {
    e.preventDefault();
    const element = document.getElementById("history");
    const rect = element?.getBoundingClientRect();
    const x = rect?.top;
    const scrollTop = document.documentElement.scrollTop
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
    if (x) {
      window.scroll({
        top: scrollTop + x + 20,
        behavior: "smooth",
      });
    }
  };

  return (
    <S.Container
      ref={checkRef}
      className={checkSize ? "container-animation" : ""}
      id="about"
    >
      <div className="container">
        <div className="title">| ABOUT</div>
        <div className="subTitle">
          {i18n.language === "en" ? (
            <>
              <span>Yeolmae Company Co., Ltd,</span> is a leading company
              contributing to the Korean art industry.
            </>
          ) : (
            <>
              미술시장을 산업화하는{" "}
              <div className="item--sub__title">
                주식회사 <span>열매컴퍼니</span> 입니다.
              </div>
            </>
          )}
        </div>
        <div className="container-content">
          <div className="left-container">
            <div className="content">
              {i18n.language === "en" ? (
                <div>
                  We will continue to strive to become the world’s{" "}
                  <span>No.1 online art platform.</span>
                </div>
              ) : (
                <div>
                  한국을 넘어{" "}
                  <span>
                    글로벌 No.1 {checkBreak && <br />}
                    아트 플랫폼
                  </span>
                  으로 성장하겠습니다.
                </div>
              )}
            </div>
            <div className="sub-content">
              {/* {t("As the first")} */}
              {i18n.language === "en" ? (
                <>
                  As the first company to introduce online joint-purchase of
                  artworks since Oct, 2018, we will expand our presence in the
                  art finance market and induce public participation by
                  incorporating the latest technologies such as AI and
                  blockchain.
                </>
              ) : (
                <>
                  국내 최초로 온라인 미술품 공동구매를 시작, 미술 금융 시장을
                  개척하고 인공지능, 블록체인 등 최신 기술을 이용하여 대중의
                  참여를 확대하고 있습니다.
                </>
              )}
            </div>
          </div>
          <div
            className={`wp-img ${i18n.language === "en" ? "wp-img__eng" : ""}`}
          >
            <div className="img-about cycle">
              <div className="name-cycle">{t("ABOUT_CYCLE_1_NAME")}</div>
              <div className="money-cycle">
                {t("ABOUT_CYCLE_1_NUMBER")}
                <span>{t("ABOUT_CYCLE_1_VALUE")}+</span>
              </div>
            </div>
            <div className="img-about1 cycle">
              <div className="name-cycle">{t("ABOUT_CYCLE_2_NAME")}</div>
              <div className="money-cycle">
                {t("ABOUT_CYCLE_2_NUMBER")}
                <span>{t("ABOUT_CYCLE_2_VALUE")}+</span>
              </div>
            </div>
            <div className="img-about2 cycle">
              <div className="name-cycle">{t("ABOUT_CYCLE_3_NAME")}</div>
              <div className="money-cycle">
                {t("ABOUT_CYCLE_3_NUMBER")}
                <span>{t("ABOUT_CYCLE_3_VALUE")}+</span>
              </div>
            </div>
          </div>
          <div className="img-mobile">
            <img
              src={ImgAboutMobile}
              alt="img mobile"
              style={{
                display: `${i18n.language === "en" ? "none" : "block"}`,
              }}
            />
            <img
              src={ImgAboutMobileEn}
              alt="img mobile"
              style={{
                display: `${i18n.language === "en" ? "block" : "none"}`,
              }}
            />
          </div>
        </div>
        <img
          src={AboutDown}
          alt="Down"
          className="icon-down"
          id="icon-down"
          onClick={(e) => ScrollToCenter(e)}
        />
      </div>
    </S.Container>
  );
}

export default About;
